<template>
  <div v-loading="loading">
    <FormBox :title="$t('message.DataRegistration.formData.baseData')">
      <el-form
        ref="ruleForm"
        :model="form"
        class="form_type1_box"
        hide-required-asterisk
      >
        <el-row :gutter="86">
          <!-- 中文姓名 -->
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('message.DataRegistration.Taxi.nameTc')">
              <el-input v-model="form.nameCn" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 外文姓名 -->
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('message.DataRegistration.Taxi.nameEn')">
              <el-input v-model="form.nameEn" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 的士駕駛員證編號 -->
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('message.taxiCertNo')">
              <el-input v-model="form.taxiCertNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 狀態 -->
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('message.DataRegistration.Taxi.status')">
              <el-select v-model="form.status" filterable disabled>
                <el-option
                  v-for="item in statusType"
                  :key="item.code"
                  :label="$t(item.label)"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 發證日期 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.Taxi.issueDate')"
            >
              <!-- <el-input v-model="form.issueDate" disabled></el-input> -->
              <el-date-picker
                v-model="form.issueDate"
                type="date"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 有效日期 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.Taxi.expiredDate')"
            >
              <!-- <el-input v-model="form.expiredDate" disabled></el-input> -->
              <el-date-picker
                v-model="form.expiredDate"
                type="date"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </FormBox>
  </div>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import FormBox from "./FormBox";
export default {
  props: ["form"],
  components: { FormBox },
  data() {
    return {
      loading: false,
      statusType: [
        {
          code: "A",
          label: "message.statusA",
        },
        {
          code: "B",
          label: "message.statusB",
        },
        {
          code: "C",
          label: "message.statusC",
        },
        {
          code: "E",
          label: "message.statusE",
        },
      ],
    };
  },
  methods: {},
  created() {},
};
</script>

<style>
</style>